import React from "react";
import Nav from './Nav';

const Head = () => {
  return <header>
  <Nav />
</header>;
};

export default Head;
